import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PerFormPrimengModule } from '@lbmx/per-form-primeng';
import { UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, ProgressSpinnerModule } from 'primeng-lts';
import { AddOptionContainerComponent } from './add-option-container.component';
import { AddOptionComponent } from './add-option.component';

@NgModule({
  declarations: [AddOptionComponent, AddOptionContainerComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    PerFormPrimengModule,
    ProgressSpinnerModule,
    ButtonModule,
    UtilsModule,
  ],
  exports: [AddOptionContainerComponent],
})
export class AddOptionModule {}
